export enum ActionsProducer {
	REQUEST_PRODUCER = 'REQUEST_PRODUCER',
	FETCH_PRODUCERS = 'FETCH_PRODUCERS'
}
